import { ArrowRight, Camera } from "lucide-react";
import { Link } from "react-router";
import {
  CCTV_ADDON_PLAN_NOTE,
  CCTV_ADDON_SECTION_LABEL,
  type CctvHighlightContent,
} from "../data/planCatalog";

export type { CctvHighlightContent };

type CctvHighlightBlockProps = CctvHighlightContent & {
  /** When true, show the full plan eligibility note (Pro / Enterprise, not Essential). */
  showPlanNote?: boolean;
  className?: string;
};

export function CctvHighlightBlock({
  summary,
  useCases,
  showPlanNote = true,
  className = "",
}: CctvHighlightBlockProps) {
  return (
    <aside
      className={`rounded-xl border border-amber-500/25 bg-slate-900/80 px-5 py-4 ${className}`}
      aria-label="Optional CCTV+ Plugin add-on"
    >
      <p className="text-amber-200/90 text-xs font-semibold uppercase tracking-wider mb-2">
        {CCTV_ADDON_SECTION_LABEL}
      </p>
      <div className="flex items-center gap-2 mb-3">
        <Camera size={16} className="text-amber-400/90 shrink-0" />
        <p className="text-slate-200 text-sm font-semibold">CCTV+ Plugin</p>
      </div>
      <p className="text-on-dark-muted text-sm leading-relaxed mb-4">{summary}</p>
      {useCases.length > 0 && (
        <ul className="space-y-2 mb-4">
          {useCases.map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm text-on-dark-muted">
              <span className="text-amber-400/80 mt-1 shrink-0">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
      {showPlanNote && (
        <p className="text-amber-100/65 text-xs leading-relaxed mb-3 border-t border-amber-500/15 pt-3">
          {CCTV_ADDON_PLAN_NOTE}
        </p>
      )}
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <Link
          to="/pricing#cctv-plugin"
          className="inline-flex items-center gap-1 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors"
        >
          See CCTV+ pricing
          <ArrowRight size={14} />
        </Link>
        <Link
          to="/solutions/cctv-surveillance"
          className="inline-flex items-center gap-1 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors"
        >
          Learn about CCTV+
          <ArrowRight size={14} />
        </Link>
      </div>
    </aside>
  );
}
